import React, { useState, useEffect, useLayoutEffect } from "react";
import "../../../../assets/scss/forms/form.scss";
import { IconContext } from "react-icons";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import {
  Card,
  CardBody,
  CardTitle,
  FormFeedback,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { MdAddCircleOutline, MdRemoveCircleOutline } from "react-icons/md";
import toTitleCase from "../../../../lib/titleCase/TitleCase";
import { ServerAddress } from "../../../../constants/ServerAddress";
import {
  setAlertType,
  setDataExist,
  setShowAlert,
} from "../../../../store/alert/Alert";
import { useNavigate } from "react-router-dom";
import { setToggle } from "../../../../store/pagination/Pagination";
import { MdAdd, MdDeleteForever } from "react-icons/md";
import { BsFillFileEarmarkPdfFill, BsFillImageFill } from "react-icons/bs";
import { ColorRing } from "react-loader-spinner";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import Title from "../../../../components/title/Title";

function AddTimeline() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user_info = useSelector((state) => state.authentication.userdetails);
  const [startDate, setstartDate] = useState(new Date());
  const [refresh, setrefresh] = useState(false);

  // ------------- Response Loader Modal---------
  const [show_loader, setshow_loader] = useState(false);

  //Circle Toogle Btn
  const [circle_btn, setcircle_btn] = useState(true);
  const [circle_btn2, setcircle_btn2] = useState(true);
  const toggle_circle = () => {
    setcircle_btn(!circle_btn);
  };
  const toggle_circle2 = () => {
    setcircle_btn2(!circle_btn2);
  };
  const [circle_btn1, setcircle_btn1] = useState(true);
  const toggle_circle1 = () => {
    setcircle_btn1(!circle_btn1);
  };
  const [is_updating, setis_updating] = useState(false);

  //  Client details
  const [client, setclient] = useState({});
  const [timeline_btn, settimeline_btn] = useState("first");
  const [package_id_list, setpackage_id_list] = useState([]);
  const [comment, setcomment] = useState("");
  let dimension_list = ["", "", "", ""];
  const [row, setrow] = useState([dimension_list]);
  const accessToken = useSelector((state) => state.authentication.access_token);
  
  // Vendor
  const [category_list, setcategory_list] = useState([]);
  const [category_n_page, setcategory_n_page] = useState(1);
  const [search_category_name, setsearch_category_name] = useState("");
  const [booking_date1, setbooking_date1] = useState("");
  // const [refresh, setrefresh] = useState(false);

  const [doc_upload, setdoc_upload] = useState("");

  const [document, setdocument] = useState([dimension_list]);
  const addDocument = () => {
    setdoc_upload("");
    dimension_list = [""];
    setdocument([...document, dimension_list]);
    setrefresh(!refresh);
  };
  const [doc_error, setdoc_error] = useState(false);
  const [doc_text, setdoc_text] = useState("");
  const delete_document = (item) => {
    alert("");
    const temp = [...document];
    const index = temp.indexOf(item);
    if (index > -1) {
      temp.splice(index, 1);
      setdocument(temp);
    }
  };

  // Start Datepicker
  const startDateChange = (date) => {
    setstartDate(date);
  };
  const addPackage = () => {
    dimension_list = ["", "", "", ""];
    setrow([...row, dimension_list]);
  };

  const deletePackage = (item) => {
    let temp = [...row];
    let temp_2 = [...package_id_list];
    const index = temp.indexOf(item);
    if (index > -1) {
      temp.splice(index, 1);
      temp_2.splice(index, 1);
    }
    setrow(temp);
    setpackage_id_list(temp_2);
  };
  // Formik Yup validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      Timeline: client.Timeline || "",
      Status: client.Status || "",
      Description: client.Description || "",
      comment: client.comment || "",
    },

    validationSchema: Yup.object({
      Timeline: Yup.string().required("Title Is Required"),
      Status: Yup.string().required("Status is required"),
    }),
    onSubmit: (values) => {
      console.log("values", values);
      send_timeline_data(values);
    },
  });

  const [category_data, setcategory_data] = useState([]);
  //------------Api for Get Users Data------------------------//
  const get_timeline = async () => {
    let category_temp = [];
    let data = [];
    try {
      const response = await axios.get(
        ServerAddress +
          `notice_board/get-Category/?search=${""}&p=${category_n_page}&records=${10}&name_search=${search_category_name}&category_name=&data=all`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        },
      );
      data = response.data.results;
      setcategory_data(data);
      console.log("timeline----", data);
      if (response.data.results.length > 0) {
        if (category_n_page === 1) {
          category_temp = response.data.results.map((v) => [
            v.id,
            toTitleCase(v.name),
          ]);
        } else {
          category_temp = [
            ...category_list,
            ...response.data.results.map((v) => [v.id, v.name]),
          ];
        }
      }
      setcategory_list(category_temp);
    } catch (err) {
      alert(`Error Occur in Get, ${err}`);
    }
  };

  useLayoutEffect(() => {
    get_timeline();
  }, [refresh]);

  const send_timeline_data = async (values) => {
    setshow_loader(true)
    const buttonType = window.event.submitter.name;

    try {
      const response = await axios.post(
        ServerAddress + "notice_board/add-Notice/",
        {
          // category: category_id,
          user: user_info.id,
          title: toTitleCase(values.Timeline).toUpperCase(),
          description: values.Description,
          date_of_expiry: booking_date1,
          status: values.Status,
          comment: values.comment,
          attachment: document,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );

      console.log("rahul---", response.data); // Log the response data to console

      if (response.data.status === "success") {
        setshow_loader(false)
        dispatch(setToggle(true));
        dispatch(setShowAlert(true));
        dispatch(setDataExist(`Timeline Added sucessfully`));
        dispatch(setAlertType("success"));
        navigate("/dashboard");
      }else{
        setshow_loader(false)
      }
      console.log("Timline", response.data);
    } catch (error) {
      setshow_loader(false)
      alert(`Error Happened while posting Timeline Data ${error}`);
    }
  };

  const [update_doc_details, setupdate_doc_details] = useState([]);
  useEffect(() => {
    if (is_updating) {
      if (update_doc_details.length !== 0) {
        let temp = [];
        let temp_list = [];
        let temp_list_2 = [];
        temp = update_doc_details;

        for (let index = 0; index < update_doc_details.length; index++) {
          temp_list.push([
            temp[index].issue_doc,
            temp[index].issue,
            temp[index].created_by,
            temp[index].id,
          ]);
        }
        setdocument(temp_list);
      }
    }
  }, [is_updating]);

  // const[bran]

  //------------ this funcation read base64 file fast -------------------
  function readFileAsBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(reader.error);

      reader.readAsDataURL(file);
    });
  }
  // ------------------ For Update Identification Details, Document Upload Update----------------
  const fileInputRef = React.useRef(null);
  function handleClickDoc(item) {
    fileInputRef.current.click();
  }
  const [doc_index, setdoc_index] = useState();

  async function handleFileChangeDoc(event, item) {
    const file = event.target.files[0];

    if (file) {
      if (
        file.type === "application/pdf" ||
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png"
      ) {
        try {
          const base64Url = await readFileAsBase64(file);
          //--------------------Update the 'item' array with the base64 data------------------------------
          document[doc_index][0] = base64Url;
          setrefresh(!refresh);
        } catch (error) {
          console.error("Error reading file:", error);
        }
      } else {
        console.log("Please select a JPEG, JPG, or PNG file.");
      }
    } else {
      console.log("No file selected.");
    }
  }

  return (
    <>
      {/* loader for avoid multipule click */}
      {show_loader ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '999'
          }}
          aria-labelledby='contained-modal-title-vcenter'
        >
          <div className='loader-container'>
            <ColorRing
              visible={true}
              height='160'
              width='160'
              ariaLabel='blocks-loading'
              wrapperStyle={{}}
              wrapperClass='blocks-wrapper'
              colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
            />
          </div>
        </div>
      ) : null}
    <React.Fragment>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit(e.values);
          return false;
        }}
      >
         <div className="mt-3">
            <PageTitle
              page={"Add Timeline"}
            />
            <Title
              title={"Add Timeline"}
              parent_title="Dashboard"
            />
          </div>

        <div>
          <Container fluid>
            <Row>
              <Col lg={12}>
                <Card>
                  <CardTitle className="mb-1 header">
                    <div
                      id="timeline"
                      value="first"
                      className="header-text-icon header-text"
                    >
                      Timline Information
                      <IconContext.Provider
                        value={{
                          className: "header-add-icon",
                        }}
                      >
                        <div onClick={toggle_circle}>
                          {circle_btn ? (
                            <MdRemoveCircleOutline />
                          ) : (
                            <MdAddCircleOutline />
                          )}
                        </div>
                      </IconContext.Provider>
                    </div>
                  </CardTitle>
                  {circle_btn ? (
                    <CardBody>
                      <FormGroup className="mb-4" row>
                        <Label
                          htmlFor="projectname"
                          className="col-form-label col-lg-2"
                        >
                          Title 
                          <span className="mandatory">*</span>
                        </Label>
                        <Col lg="10">
                          <Input
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.Timeline || ""}
                            invalid={
                              validation.touched.Timeline &&
                              validation.errors.Timeline
                                ? true
                                : false
                            }
                            id="input"
                            name="Timeline"
                            type="text"
                            className="form-control"
                            placeholder="Enter Your Title..."
                          />
                          {validation.touched.Timeline &&
                            validation.errors.Timeline && (
                              <FormFeedback type="invalid">
                                {validation.errors.Timeline}
                              </FormFeedback>
                            )}
                        </Col>
                      </FormGroup>
                      <FormGroup className="mb-4" row>
                        <Label
                          htmlFor="projectdesc"
                          className="col-form-label col-lg-2"
                        >
                          Description
                        </Label>
                        <Col lg="10">
                          <textarea
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.Description || ""}
                            invalid={
                              validation.touched.Description &&
                              validation.errors.Description
                                ? true
                                : false
                            }
                            className="form-control"
                            name="Description"
                            id="input"
                            rows="3"
                            placeholder="Enter  Description..."
                          />
                          {validation.touched.Description &&
                            validation.errors.Description && (
                              <FormFeedback type="invalid">
                                {validation.errors.Description}
                              </FormFeedback>
                            )}
                        </Col>
                      </FormGroup>
                      <FormGroup className="mb-4" row>
                        <Label className="col-form-label col-lg-2">
                          Expiry Date*
                        </Label>
                        <Col lg="10">
                          <Row>
                            <Col lg={3} md={6} sm={6} className="pr-0">
                              <div>
                                <input
                                  type="date"
                                  className="form-control d-block form-control-md "
                                  id="input"
                                  value={booking_date1}
                                  onChange={(val) => {
                                    setbooking_date1(val.target.value);
                                  }}
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </FormGroup>

                      <FormGroup className="mb-4" row>
                        <Label className="col-form-label col-lg-2">
                          Status
                        </Label>
                        <Col lg="10">
                          <Row>
                            <Col lg={3} md={6} sm={6} className="pr-0">
                              <div>
                                <Input
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Status || ""}
                                  invalid={
                                    validation.touched.Status &&
                                    validation.errors.Status
                                      ? true
                                      : false
                                  }
                                  min={0}
                                  type="text"
                                  name="Status"
                                  className="form-control-md"
                                  id="input"
                                  style={{ marginBottom: "15px" }}
                                  placeholder="Please Enter Status"
                                />
                              </div>
                              {validation.touched.Status &&
                                validation.errors.Status && (
                                  <FormFeedback type="invalid">
                                    {validation.errors.Status}
                                  </FormFeedback>
                                )}
                            </Col>
                          </Row>
                        </Col>
                      </FormGroup>

                      <FormGroup className="mb-4" row>
                        <Label
                          htmlFor="projectdesc"
                          className="col-form-label col-lg-2"
                        >
                          Comment
                        </Label>
                        <Col lg="10">
                          <textarea
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.comment || ""}
                            invalid={
                              validation.touched.comment &&
                              validation.errors.comment
                                ? true
                                : false
                            }
                            className="form-control"
                            name="comment"
                            id="input"
                            rows="3"
                            placeholder="Enter  comment..."
                          />
                          {validation.touched.comment &&
                            validation.errors.comment && (
                              <FormFeedback type="invalid">
                                {validation.errors.comment}
                              </FormFeedback>
                            )}
                        </Col>
                      </FormGroup>
                      {/*Button */}
                    </CardBody>
                  ) : null}

                  <div className="m-3" id="section1">
                    <Card className="shadow bg-white rounded">
                      <CardTitle className="mb-1 header">
                        <div className="header-text-icon header-text">
                          Document Details
                          <IconContext.Provider
                            value={{
                              className: "header-add-icon",
                            }}
                          >
                            <div onClick={toggle_circle1}>
                              {circle_btn1 ? (
                                <MdRemoveCircleOutline />
                              ) : (
                                <MdAddCircleOutline />
                              )}
                            </div>
                          </IconContext.Provider>
                        </div>
                      </CardTitle>
                      {circle_btn1 ? (
                        <CardBody>
                          <Row>
                            <Col lg={3} md={3} sm={3}>
                              <Label className="header-child">
                                Upload Photo
                              </Label>
                              {document.map((item, index) => {
                                let get_doc =
                                  item[0] !== null &&
                                  typeof item[0] === "string"
                                    ? item[0].split("/")
                                    : [];

                                let get_doc_name =
                                  get_doc.length > 0
                                    ? get_doc[get_doc.length - 1]
                                    : "";

                                return (
                                  <div key={index} style={{ width: "100%" }}>
                                    {is_updating ? (
                                      <>
                                        <div style={{ display: "flex" }}>
                                          <button
                                            type="button"
                                            style={{
                                              width: "35%",
                                              border: " 0.1px solid gray",
                                              borderRight: "none",
                                              fontSize: "10px",
                                              height: "26px",
                                              fontWeight: "540",
                                              color: "gray",
                                            }}
                                            onClick={() => {
                                              alert(index);
                                              setdoc_index(index);
                                              handleClickDoc(item);
                                            }}
                                          >
                                            Update
                                          </button>
                                          <input
                                            value={get_doc_name}
                                            disabled
                                            style={{
                                              marginBottom: "16.5px",
                                              width: "75%",
                                              fontSize: "10.5px",
                                              height: "26px",
                                              border: "0.1px solid gray",
                                              borderLeft: "0.1px solid black",
                                            }}
                                          />
                                          {is_updating ? null : (
                                            <input
                                              ref={fileInputRef}
                                              type="file"
                                              style={{
                                                display: "none",
                                              }}
                                              accept=".pdf, .jpeg, .jpg, .png, image/jpeg, image/jpg, image/png"
                                              onChange={(e) => {
                                                handleFileChangeDoc(e, item);
                                              }}
                                            />
                                          )}
                                          <span style={{ marginLeft: "8px" }}>
                                            {" "}
                                            <a
                                              href={`${item[0]}`}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              {item[0] &&
                                              item[0]
                                                .toLowerCase()
                                                .endsWith(".pdf") ? (
                                                <BsFillFileEarmarkPdfFill
                                                  size={25}
                                                />
                                              ) : (
                                                <BsFillImageFill size={25} />
                                              )}
                                            </a>
                                          </span>
                                        </div>
                                      </>
                                    ) : (
                                      <Input
                                        className="form-control d-block from control-md"
                                        bsSize="sm"
                                        type="file"
                                        style={{
                                          marginBottom: "15px",
                                        }}
                                        name="degree_doc"
                                        id="input-s"
                                        accept=".pdf, .jpeg, .jpg, .png, image/jpeg, image/jpg, image/png"
                                        onChange={(event) => {
                                          const file = event.target.files[0];

                                          if (
                                            file &&
                                            (file.type === "application/pdf" ||
                                              file.type === "image/jpeg" ||
                                              file.type === "image/jpg" ||
                                              file.type === "image/png")
                                          ) {
                                            const reader = new FileReader();
                                            reader.onload = () => {
                                              const base64Url = reader.result;
                                              item[0] = base64Url; // Set the value at index 2 in the 'item' directly
                                              setrefresh(!refresh);
                                            };

                                            reader.readAsDataURL(file);
                                          } else {
                                            // Handle invalid file type error
                                            console.log(
                                              "Please select a JPEG, JPG, or PNG file.",
                                            );
                                          }
                                        }}
                                      />
                                    )}
                                  </div>
                                );
                              })}
                            </Col>

                            {/* //----Delete---/// */}
                            <Col lg={1} md={1} sm={1}>
                              <div className="mb-3">
                                {document.length > 1 ? (
                                  <Label className="header-child">Delete</Label>
                                ) : null}
                                {document.map((item, index) => (
                                  <IconContext.Provider
                                    key={index}
                                    value={{
                                      className: "icon multi-input",
                                    }}
                                  >
                                    {document.length > 1 ? (
                                      <div
                                        className="mb-2 mt-2"
                                        onClick={() => {
                                          delete_document(item);
                                        }}
                                      >
                                        <MdDeleteForever
                                          size={20}
                                          style={{
                                            justifyContent: "center",
                                            color: "red",
                                            cursor: "pointer",
                                            marginBottom: "15px",
                                          }}
                                        />
                                      </div>
                                    ) : null}
                                  </IconContext.Provider>
                                ))}
                              </div>
                            </Col>
                            {doc_error ? (
                              <div
                                style={{
                                  color: "#f46a6a",
                                  fontSize: "12px",
                                  marginBottom: "12px",
                                }}
                              >
                                {doc_text}
                              </div>
                            ) : null}

                            <div>
                              <span
                                className="link-text"
                                onClick={() => {
                                  addDocument();
                                }}
                              >
                                <IconContext.Provider
                                  value={{
                                    className: "icon",
                                  }}
                                >
                                   <button
                                    className="hidden-button"
                                    type="button"
                                  ></button>
                                  <MdAdd />
                                </IconContext.Provider>
                                Add Another
                              </span>
                            </div>
                          </Row>
                        </CardBody>
                      ) : null}
                    </Card>
                  </div>
                </Card>
              </Col>
            </Row>
            <div className=" m-3">
              <Col lg={12}>
                <div className="mb-1 footer_btn">
                  <button
                    className="btn btn-info m-2"
                    type="submit"
                    name="save_add"
                  >
                    Save
                  </button>

                  <button
                    type="button"
                    className="btn btn-info m-2 "
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </button>
                </div>
              </Col>
            </div>
          </Container>
        </div>
      </Form>
    </React.Fragment>
    </>
  );
}

export default AddTimeline;
